import React from 'react';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Legal</span>
          <h1 className="section-title">Privacy Policy</h1>
          <p className="section-subtitle">Last updated: May 1, 2026</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p className="legal-intro">
              At AIScaler ("we", "our", "us"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform at aiscaler.app.
            </p>

            <h2>1. Information We Collect</h2>
            <h3>1.1 Personal Information</h3>
            <p>When you create an account or contact us, we may collect:</p>
            <ul>
              <li>Name and email address</li>
              <li>Billing information (processed securely via Stripe)</li>
              <li>Company name and job title (optional)</li>
              <li>Communication preferences</li>
            </ul>

            <h3>1.2 Usage Data</h3>
            <p>We automatically collect certain information when you use our platform:</p>
            <ul>
              <li>Device and browser information</li>
              <li>IP address and approximate location</li>
              <li>Pages visited and features used</li>
              <li>Processing statistics (file types, enhancement modes used)</li>
            </ul>

            <h3>1.3 Uploaded Content</h3>
            <p>When you use our enhancement services, we temporarily process the files you upload (images, videos, documents). These files are:</p>
            <ul>
              <li>Processed solely for the purpose of providing our enhancement services</li>
              <li>Never used to train our AI models</li>
              <li>Auto-deleted after a configurable retention period</li>
              <li>Stored securely with encryption at rest</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and manage subscriptions</li>
              <li>Send service-related communications</li>
              <li>Respond to support requests and inquiries</li>
              <li>Monitor platform usage for performance optimization</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>3. Data Sharing</h2>
            <p>We do not sell your personal information. We may share data with:</p>
            <ul>
              <li><strong>Service providers:</strong> Payment processors (Stripe), cloud infrastructure providers, analytics tools</li>
              <li><strong>Legal compliance:</strong> When required by law, regulation, or legal process</li>
              <li><strong>Business transfers:</strong> In connection with a merger, acquisition, or asset sale</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures including:</p>
            <ul>
              <li>Encryption in transit (TLS) and at rest</li>
              <li>Secure file storage infrastructure</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>Access controls and authentication</li>
              <li>Automatic file deletion after processing</li>
            </ul>

            <h2>5. Data Retention</h2>
            <p>We retain your personal information for as long as your account is active or as needed to provide services. Uploaded files are automatically deleted after processing, with a configurable retention period. You can request deletion of your account and associated data at any time.</p>

            <h2>6. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to data processing</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
            </ul>

            <h2>7. GDPR Compliance</h2>
            <p>For users in the European Economic Area (EEA), we comply with the General Data Protection Regulation (GDPR). We process data based on legitimate interest, contractual necessity, and consent where applicable.</p>

            <h2>8. Cookies</h2>
            <p>We use essential cookies for platform functionality and optional analytics cookies to improve our services. You can manage cookie preferences through your browser settings.</p>

            <h2>9. Children's Privacy</h2>
            <p>AIScaler is not intended for children under 16. We do not knowingly collect information from children under 16.</p>

            <h2>10. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by email or through a notice on our platform.</p>

            <h2>11. Contact Us</h2>
            <p>If you have questions about this Privacy Policy or your data, please contact us at:</p>
            <ul>
              <li><strong>Email:</strong> info@aiscaler.app</li>
              <li><strong>Website:</strong> aiscaler.app</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
